<template>
  <div>
    <!-- Kejuruteraan Kesihatan Menu -->
    <div
      class="kejuruteraan-kesihatan-menu"
      :class="{ open: isKejuruteraanKesihatanMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>KEJURUTERAAN KESIHATAN</span>
          </li> 
        -->
        <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum">
            Hotspot Banjir
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/kolam-takungan">
            Kolam Takungan Banjir  
          </RouterLink>
        </li>
        <!--
          <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/perparitan">
          Perparitan 
          </RouterLink>
          </li> 
        -->
        <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/kolam-renang">
            Kolam Renang
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/perangkap-minyak">
            Perangkap Minyak
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/lampu-jalan">
            Lampu Jalan
          </RouterLink>
        </li>
        <!--
          <li>
          <RouterLink to="/kejuruteraan-kesihatan-umum/kumbahan-bukan-najis">
          Kumbahan Bukan Najis
          </RouterLink>
          </li> 
        -->
      </ul>
    </div>
    <div
      v-if="isKejuruteraanKesihatanMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isKejuruteraanKesihatanMenuOpen"
      class="kejuruteraan-kesihatan-toggle-button"
      @click="toggleKejuruteraanKesihatanMenu"
    >
      <span class="vertical-text">KEJURUTERAAN KESIHATAN</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isKejuruteraanKesihatanMenuOpen = ref(false)

const toggleKejuruteraanKesihatanMenu = () => {
  isKejuruteraanKesihatanMenuOpen.value = !isKejuruteraanKesihatanMenuOpen.value
  if (isKejuruteraanKesihatanMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isKejuruteraanKesihatanMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-kejuruteraan-kesihatan-menu', () => {
  isKejuruteraanKesihatanMenuOpen.value = false
})
</script>

<style scoped>
/* Kejuruteraan Kesihatan Menu */
.kejuruteraan-kesihatan-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.kejuruteraan-kesihatan-menu.open {
  transform: translateX(0);
}

.kejuruteraan-kesihatan-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.kejuruteraan-kesihatan-menu li {
  margin-bottom: 10px;
}

.kejuruteraan-kesihatan-menu a,
.kejuruteraan-kesihatan-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Kejuruteraan Kesihatan Toggle Button */
.kejuruteraan-kesihatan-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.kejuruteraan-kesihatan-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
